
















import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { analysisStores } from '@/store/poultry/analysis';
import dayjs, { Dayjs} from 'dayjs';
import { ScoreAnalysis } from '@/models/poultry/analysis.model';
import { setFormattedDate } from '@/utils/date.formatter';

@Component({
  components: {}
})

export default class SwabSampleAnalysisTableBody extends Vue {
  store = analysisStores.swab_sample.list;

  get swab_samples() {
    return this.store.sortedSwabSample;
  }

  getPublishedMonth(date: string) {
    return setFormattedDate(date);
  }
}
